// src/features/risks/hooks/useFocusOnNode.ts
import { useReactFlow } from "@xyflow/react"
import { useCallback } from "react"

export function useFocusOnNode() {
  const { getNode, setCenter, setNodes } = useReactFlow()

  const focusOnNode = useCallback(
    (nodeId: string, zoom = 1.2, duration = 500, highlight = false) => {
      const node = getNode(nodeId)
      if (node) {
        setCenter(node.position.x, node.position.y, { zoom, duration })

        if (highlight) {
          // active le flag highlight
          setNodes((nds) => nds.map((n) => (n.id === nodeId ? { ...n, data: { ...n.data, highlight: true } } : n)))

          // reset après 2s
          setTimeout(() => {
            setNodes((nds) => nds.map((n) => (n.id === nodeId ? { ...n, data: { ...n.data, highlight: false } } : n)))
          }, 2000)
        }
      } else {
        console.warn(`Node with id "${nodeId}" not found.`)
      }
    },
    [getNode, setCenter, setNodes]
  )

  return { focusOnNode }
}
